export default __webpack_public_path__ + "locales/de/SingleSignOn.json?hash=6fce2aa5fd26053ac43194f1c5fa02e3";